import { signalingBaseUrl } from './config';

export interface CreateRoomResponse {
  roomId: string;
  expiresAt: string;
}

export interface RoomStatus {
  exists: boolean;
  online: boolean;
  receiverConnected: boolean;
  expiresAt?: string;
}

/** POST /api/rooms — create a transfer room. */
export async function createRoom(): Promise<CreateRoomResponse> {
  const res = await fetch(`${signalingBaseUrl()}/api/rooms`, { method: 'POST' });
  if (!res.ok) throw new Error(`Failed to create room (${res.status})`);
  return res.json() as Promise<CreateRoomResponse>;
}

/** GET /api/rooms/:id — room presence/status. */
export async function getRoomStatus(roomId: string): Promise<RoomStatus> {
  const res = await fetch(`${signalingBaseUrl()}/api/rooms/${encodeURIComponent(roomId)}`);
  if (res.status === 404) {
    return { exists: false, online: false, receiverConnected: false };
  }
  if (!res.ok) throw new Error(`Failed to fetch room status (${res.status})`);
  return res.json() as Promise<RoomStatus>;
}
